 
// TypeScript declaration for Digio
declare global {
    interface Window {
        Digio: any; // Type declaration for Digio
    }
}
 
export function InitiateDigio(params1,params2,params3) {
  // debugger
        if (typeof window !== 'undefined' && typeof window.Digio !== 'undefined') {
            const options = {
                environment: 'production', //production //stage
                callback: (response: any) => {
                  // debugger
                  console.log('response.message', response.message);
                    if (response.message === 'KYC process completed') {
                          window.location.replace(window.location.origin + '/partner/document-upload' + "?status=0" + "&kid=" + params1);
                         //  window.location.replace('http://localhost:5173/digilocker' + "/?status=success" + "&kid=" + params1);
                    } else if (response.error_code === "TERMINATED") {
                        window.location.replace(window.location.origin + '/partner/document-upload' + "?status=terminated" + "&kid=" + params1);
                       //  window.location.replace('http://localhost:5173/digilocker' + "/?status=success" + "&kid=" + params1);
                  }
                    else {
                        //  window.location.replace('http://localhost:5173/digilocker' + "/?status=cancel");
                         window.location.replace(window.location.origin + '/partner/document-upload' + "?status=1");
                    }
                    digioInstance.cancel();
                },
                is_iframe: true,
                is_redirection_approach: false,
                redirect_url: '',
            };
 
            const digioInstance = new window.Digio(options);
 
            try {
                digioInstance.init();
                digioInstance.submit(params1,params2,params3);
                // digioInstance.submit('KID240902181619095QYVH5OUI8OD1X9','9762622319');
            } catch (err) {
                if (err instanceof Error) {
                    console.error('Error:', err.message);
                } else {
                    console.error('An unknown error occurred');
                }
            }
        } else {
            console.error('Digio SDK is not available');
        }
 
}
 
 
interface Theme {
    primaryColor: string;
    secondaryColor: string;
  }
 
  interface DigioOptions {
    environment: string;
    callback: (response: any) => void;
    logo: string;
    is_redirection_approach: boolean;
    redirect_url: string;
    theme: Theme;
    event_listener: (event: any) => void;
  }
 
export function InitiateDigioSelfie(params1,params2,params3) {
    if (typeof window !== 'undefined' && typeof window.Digio !== 'undefined') {
 
        const options: DigioOptions = {
            environment: "production", //stage // production
            callback: function (response: any): void {              
              if (response.hasOwnProperty("error_code")) {
                console.log("Error occurred in process");
              } else {
                console.log("Signing completed successfully");
              }
            },
            logo: "https://www.mylogourl.com/image.png",
            is_redirection_approach: true,
            redirect_url: window.location.origin + '/selfie-upload' + "?status=0" + "&kid=" + params1,
            theme: {
              primaryColor: "#AB3498",
              secondaryColor: "#000000",
            },
            event_listener: function (event: any): void {
            // Display the event and response in the HTML page
              const responseDiv = document.getElementById("response");
              if (responseDiv) {
                const eventMessage = document.createElement("p");
                eventMessage.textContent = "Event: " + event.event;
                responseDiv.appendChild(eventMessage);
              }
            },
          };
         
           const digioInstance = new window.Digio(options);
 
             try {
            digioInstance.init();
            digioInstance.submit(params1,params2,params3);
            // digioInstance.submit('KID240902181619095QYVH5OUI8OD1X9','9762622319');
        } catch (err) {
            if (err instanceof Error) {
                console.error('Error:', err.message);
            } else {
                console.error('An unknown error occurred');
            }
        }
 
       
    } else {
        window.location.reload();
        console.error('Digio SDK is not available');
    }
 
}
 
 
 
export function isImageMostlyEmptyOrDots(file: File): Promise<boolean> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
 
        const ctx = canvas.getContext("2d");
        if (!ctx) return resolve(true); // fail-safe: treat as invalid
 
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
 
        let nonTransparentPixels = 0;
        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];
          if (alpha > 30) {
            nonTransparentPixels++;
          }
        }
 
        const totalPixels = canvas.width * canvas.height;
        const visibleRatio = nonTransparentPixels / totalPixels;
 
        resolve(visibleRatio < 0.005);
      };
 
      img.onerror = () => resolve(true);
      img.src = reader.result as string;
    };
 
    reader.onerror = () => resolve(true);
    reader.readAsDataURL(file); // Avoids blob:
  });
}